import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import './index.css'
import BEMHelper from 'react-bem-helper'
const classes = new BEMHelper('logo')

export default class Logo extends Component {
  static propTypes = {
    className: PropTypes.string,
  }

  constructor (props) {
    super(props)

    this.state = {
      modifer: null,
    }
  }

  componentDidMount () {
    this.randomModifier()
  }

  randomModifier = () => {
    const modifiers = [
      'www',
      'comments-1',
      'comments-2',
      'comments-3',
      'arrow',
      'double-arrow',
      'compare',
      'html',
      'markdown',
      'equals',
      'unequals',
      'func',
      'json',
      'shout',
      'path',
      'if',
    ]

    const modifier =
      modifiers[Math.round(Math.random() * (modifiers.length - 1))]

    this.setState({
      modifier,
    })
  }

  render () {
    const { className } = this.props
    const { modifier } = this.state

    return (
      <Link
        to="/"
        {...classes('', modifier, className)}
        onMouseOut={this.randomModifier}
      >
        Appresso
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Logo/index.js